module.exports = __webpack_public_path__ + "static/media/react_logo.89ef3bf4.jpg";